import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import classnames from 'classnames';

export default class SectionWaypoint extends React.Component {
    static propTypes = {
        section: PropTypes.string.isRequired,
        onEnter: PropTypes.func.isRequired,
        onLeave: PropTypes.func,
        children: PropTypes.node
    }

    static defaultProps = {
        onLeave: () => {}
    }

    handleOnEnter = () => this.props.onEnter( this.props.section )
    handleOnLeave = () => this.props.onLeave( this.props.section )

    render() {
        const { section, onEnter, onLeave, children, ...props } = this.props; //eslint-disable-line no-unused-vars
        return (
            <Waypoint bottomOffset="50%" topOffset="49%" onLeave={this.handleOnLeave} onEnter={ this.handleOnEnter }>
                <section role="region" id={section} {...props}>
                    { this.props.children }
                </section>
            </Waypoint>
        );
    }
}

class WaypointNav extends React.Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
        section: PropTypes.string.isRequired,
        activeSection: PropTypes.string.isRequired
    }

    handleClick = e => {
        e.preventDefault();
        this.props.onClick( this.props.section );
    }

    render() {
        const { onClick, section, activeSection, ...props } = this.props; //eslint-disable-line no-unused-vars

        return (
            <a
                {...props}
                href={`#${section}`}
                className={classnames( 'btn-scroll', { active: activeSection === section } )}
                onClick={this.handleClick}
                aria-label={section}
            >&nbsp;</a>
        );
    }
}

SectionWaypoint.Nav = WaypointNav;
